module.exports = {
  UNLIMITED: 'ecommerce_unlimited',
  PROFESSIONAL: 'ecommerce_professional',
  BASIC: 'ecommerce_basic',
};
